<template>
  <div id="app" :lang="$i18n.locale">
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
@import url('@/assets/fonts/fonts.css');
#app {
  font-family: HYQiHei_55W;
  text-align: center;
  color: #2c3e50;
  background-color: #fff;
  height: 100%;
  user-select: none;
}

nav a {
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>